module.exports = __webpack_public_path__ + "img/QRCode.222c12f5.jpg";